module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-01-31 100651.35b6eb45.png";